import { Controller } from '@hotwired/stimulus'

// Centers a column of a horizontally scrolling table on connect, so a wide grid
// (the time study schedule) opens on today's column instead of on the 1st.
export default class extends Controller {
  static values = {
    containerSelector: { type: String, default: '.gds--table__scroll-container' },
    targetSelector: String
  }

  connect() {
    const container = this.element.querySelector(this.containerSelectorValue)
    const target = container?.querySelector(this.targetSelectorValue)
    if (!target) return

    const targetLeft =
      target.getBoundingClientRect().left - container.getBoundingClientRect().left + container.scrollLeft
    container.scrollLeft = targetLeft - (container.clientWidth - target.offsetWidth) / 2
  }
}
